module.exports = __webpack_public_path__ + "static/media/circle-arrow-l.97a3209f.svg";